import { ROLES } from './roles'

export enum USER_ROLE {
  CREATOR = 'CREATOR',
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  OPERATOR_MEYREAL = 'OPERATOR_MEYREAL',
  OPERATOR_MEYFI = 'OPERATOR_MEYFI',
}

/**
 * Marker permission ID assigned to a user by the backend to identify their role.
 * The presence of one of these IDs in the user's permissions array determines the role.
 */
export const USER_ROLE_MARKERS: Record<USER_ROLE, number> = {
  [USER_ROLE.SUPER_ADMIN]: ROLES.SUPER_ADMIN,
  [USER_ROLE.CREATOR]: ROLES.PERMISSION_V2_CREATOR,
  [USER_ROLE.ADMIN]: ROLES.PERMISSION_V2_ADMIN_VIEW,
  [USER_ROLE.OPERATOR_MEYREAL]: ROLES.PERMISSION_V2_OPERATOR_MEYREAL,
  [USER_ROLE.OPERATOR_MEYFI]: ROLES.PERMISSION_V2_OPERATOR_MEYFI,
}

/**
 * Order matters: Super Admin must be checked first since it bypasses all other roles.
 */
const USER_ROLE_DETECTION_ORDER: USER_ROLE[] = [
  USER_ROLE.SUPER_ADMIN,
  USER_ROLE.CREATOR,
  USER_ROLE.ADMIN,
  USER_ROLE.OPERATOR_MEYREAL,
  USER_ROLE.OPERATOR_MEYFI,
]

export const deriveUserRole = (permissions: number[]): USER_ROLE | null => {
  for (const role of USER_ROLE_DETECTION_ORDER) {
    if (permissions.includes(USER_ROLE_MARKERS[role])) return role
  }
  return null
}

export const USER_ROLE_LABELS: Record<USER_ROLE, string> = {
  [USER_ROLE.CREATOR]: 'Creator',
  [USER_ROLE.ADMIN]: 'Admin',
  [USER_ROLE.SUPER_ADMIN]: 'Super Admin',
  [USER_ROLE.OPERATOR_MEYREAL]: 'Operator Meyreal',
  [USER_ROLE.OPERATOR_MEYFI]: 'Operator Meyfi',
}

export const USER_ROLE_OPTIONS = (Object.keys(USER_ROLE_LABELS) as USER_ROLE[]).map((value) => ({
  value,
  label: USER_ROLE_LABELS[value],
}))

export const USER_ROLE_DESCRIPTIONS: Record<USER_ROLE, string> = {
  [USER_ROLE.CREATOR]: 'Tạo dữ liệu, cấu hình ban đầu. Chỉ cho phép tạo admin.',
  [USER_ROLE.ADMIN]: 'Quản trị vận hành cơ bản. Chỉ xem toàn bộ tính năng, không CRUD.',
  [USER_ROLE.SUPER_ADMIN]: 'Toàn quyền hệ thống.',
  [USER_ROLE.OPERATOR_MEYREAL]: 'Vận hành nghiệp vụ Meyreal. CRUD PTO, DAO, Staking NFT, User MR.',
  [USER_ROLE.OPERATOR_MEYFI]:
    'Vận hành nghiệp vụ Meyfi. CRUD Vesting, Staking tokens, Affiliate, User MF.',
}
